export const PAGE_SIZE = 20;
export const THREADS = 4;
